module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-no1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("WHAT IS PATCHWORK?")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although this book concentrates on quilting techniques, many of you will be quilting patchworked projects so I thought I would give you an overview of a few different techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Patchwork is the method of sewing together small pieces of fabric to create a larger piece. It can make up the top layer of fabric in a quilt, or can be left unquilted to make projects for the home, clothing and other craft items.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Patchwork is a technique that has been around for centuries, serving both decorative and practical purposes. It is decorative as both intricate and simple (and, under these headings, mosaic and illusional) designs can be created through clever use of shapes and colours. Patchwork is practical, too, as scraps of fabric can be re-purposed so as not to waste unwanted or worn-out items of clothing, and – by the same token – could also create memory pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a beginner, you may wish to start by simply sewing squares of fabric together with colours in no particular order, or organized into a tiled pattern (most of us start our journey with the basic nine-patch block); then, you can move on to half-square and quarter-square triangles, diamonds, hexagons and more of the many geometric shapes traditionally used in patchwork.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Templates are available to help with accurate cutting and fussy cutting, which is a way of placing the template over a specific area of fabric to position the print. For instance, you may like to pick out a flower to place in the centre of a hexagon – special, clear templates allow you to see the flower so you can centralize it before cutting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Patchwork techniques include hand or machine piecing; English paper piecing (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 76")]), _vm._v("); foundation piecing, which uses a pre-printed background fabric (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 43")]), _vm._v("); and crazy patchwork. Large items such as bed quilts are usually broken down into blocks – these are repeatable squares of patchworked pieces arranged either to tessellate or tile across the whole quilt (for examples of this see the Mini Chicken Quilt on "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 48")]), _vm._v(" and the Table Runner on "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 62")]), _vm._v("), or separated with long strips of fabric that act as borders, known as ‘sashing’ (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 66")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While patchwork and quilting do seem to go hand in hand, they are two very different techniques that can be used either together or separately, giving you endless choices of exciting projects to create!")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionr"
  }, [_vm._v("Nine-patch block.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionr"
  }, [_vm._v("Half-square triangles.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionr"
  }, [_vm._v("English paper piecing ‘jewel’ design.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c67f896","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Frontmatter05.vue
// module id = 84
// module chunks = 0